<template>
  <Toast />
  <ConfirmDialog group="templating">
    <template #message="slotProps">
        <div class="flex flex-column align-items-center w-full gap-3 surface-border">
            <p class="white-space">{{ slotProps.message.message }}</p>
        </div>
    </template>
  </ConfirmDialog>
  <p v-if="storename" class="lead text-muted"><strong>Store Name:</strong> {{ storename }}</p>
  <p class="lead text-muted"><strong>User Role:</strong> {{ role }}</p>
  <p v-if="role === 'EnterpriseAdmin'" class="lead text-muted"><strong>Enterprise Name:</strong> {{ enterprisename }}</p>
</template>

<script lang="ts" setup>
import { useAuth0 } from "@auth0/auth0-vue";
import ApiService from '../service/api.service';
import { onBeforeMount } from 'vue';
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

const storeid = ref('');
const role = ref('');
const selectedEnterpriseStore = ref();
const enterprisestores = ref([]);
const store = useStore();
const auth0 = useAuth0();
const enterpriseid = ref('');
const storename = ref('');
const enterprisename = ref('');

onBeforeMount(async () => {
  role.value = store.state.role;
  storeid.value = store.state.storeid;
  enterpriseid.value = store.state.enterpriseid;
  storename.value = store.state.storename;

  if (role.value == 'EnterpriseAdmin') {
    const accessToken = await auth0.getAccessTokenSilently();
    enterprisename.value = await ApiService.getEnterpriseNameById(accessToken, enterpriseid.value);
    enterprisestores.value = store.state.enterprisestores;
    selectedEnterpriseStore.value = enterprisestores.value.find(item => item.StoreId == storeid.value);
  }
});
</script>
<style>
p {
  white-space: pre-line;
}
</style>